export default "__VITE_ASSET__TxmzntpC__"